// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input__help-block {
  position: absolute;
  top: -25px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/Input/Input.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;AACJ","sourcesContent":[".input__help-block {\n    position: absolute;\n    top: -25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
